import axios from "axios";

const api_base_url = process.env.REACT_APP_API_BASEURL + "/ProducerCode";

export const downloadCDRCStatusReconciliationFindings = async (
  batchId: number,
) => {
  return await axios.get(
    `${api_base_url}/CDRCStatusReconciliation/Findings/${batchId}/Download`,
    {
      responseType: "blob",
    },
  );
};
